export default __webpack_public_path__ + "static/Screenshot1-979171f342f9328d40302901ad896b3e.jpg";